<div #host class="input-icon filter" [ngClass]="{ 'has-selection': hasSelection }">
  <input type="text" [(ngModel)]="search" (keyup)="searchKeyup()"/>
  <div class="icons">
    <span class="icon-btn">
      <t-icon name="search"></t-icon>
    </span>
  </div>

  <ul class="results" *ngIf="showItems">
    <li *ngFor="let entity of entities"
          [ngClass]="{ selected: selectedItem && entity.id === selectedItem.id }"
          (click)="select(entity)">
          {{ entity.name }}
        </li>
  </ul>
</div>